/**
 * «Сменить пароль» — the two steps the boards draw.
 *
 * «SETTINGS PAGE - change password 1» asks for the new password over the line
 * «не менее 8 символов»; «- change password 2» asks for it again. Both are the
 * same panel with «Подтвердить» pinned above the footer.
 *
 * The boards draw no error state, so there is none: the button is simply dead
 * until what has been typed satisfies the step — eight characters on the first,
 * an exact match on the second. That is the whole rule the design states, and
 * inventing a red «пароли не совпадают» line would be putting words on Marina's
 * screen that she did not write.
 *
 * Nothing is stored. There are no accounts in this build (DECISIONS D4), so
 * this is the screen and its validation, not a credential change — and it
 * deliberately never writes what is typed anywhere, not even to memory beyond
 * the life of this component.
 */
import { useState } from 'react';
import { Dialog } from './Dialog.js';

export function PasswordChange({ onDone }: { onDone: () => void }) {
  const [step, setStep] = useState<1 | 2>(1);
  const [first, setFirst] = useState('');
  const [again, setAgain] = useState('');

  const shortEnough = first.length >= 8;
  const matches = again === first && again.length > 0;

  if (step === 1) {
    return (
      <Dialog
        size="prompt"
        label="Сменить пароль"
        title="Введите новый пароль"
        action="Подтвердить"
        actionDisabled={!shortEnough}
        onAction={() => setStep(2)}
        onClose={onDone}
      >
        <p className="dlg-hint">не менее 8 символов</p>
        <input
          className="dlg-field"
          type="password"
          value={first}
          autoFocus
          autoComplete="new-password"
          onChange={(e) => setFirst(e.target.value)}
          aria-label="Новый пароль"
        />
      </Dialog>
    );
  }

  return (
    <Dialog
      size="prompt"
      label="Подтвердите новый пароль"
      /* The board breaks this title after «Подтвердите». */
      title={'Подтвердите\nновый пароль'}
      action="Подтвердить"
      actionDisabled={!matches}
      onAction={onDone}
      onClose={onDone}
    >
      <input
        className="dlg-field"
        type="password"
        value={again}
        autoFocus
        autoComplete="new-password"
        onChange={(e) => setAgain(e.target.value)}
        aria-label="Повторите новый пароль"
      />
    </Dialog>
  );
}
